/**
* @name:固定资产与规章制度
* @author kk
* @date 2019/11/6
*/
<template>
  <div>
    <div class="gd-gz-box">
      <!--<div class="gd-btn btn" @click="ShowGD()"><img src="../../assets/images/shitang/Gdzc.png" alt="">固定资产<i-->
          <!--class="el-icon-arrow-right"></i></div>-->
      <div class="gz-btn btn" @click="ShowGZ()"><img src="../../assets/images/shitang/Gzzd.png" alt="">规章制度<i
          class="el-icon-arrow-right"></i></div>
    </div>
    <transition name="slide-left-fade">
      <popup title="规章制度" class="people-pop" v-if="isShowGZ" width="775px" @closeEvent="isShowGZ = false">
        <div class="regulation-content" v-if="regulationInfo.rmId">
          <div class="info-content" v-html="regulationInfo.regulationContent">
          </div>
          <div class="info-img" v-if="regulationInfo.fileId.length>0">
            <p v-for="(img, i) in regulationInfo.fileId" :key="i">
              <img :src="imgUrl+img" alt=""  @click="showPic(imgUrl+img)"></p></div>
        </div>
        <div class="no-the-data" style="min-height: 130px" v-if="!regulationInfo.rmId">
          <div>
            <i class="iconfont icon-shezhi dzi"></i>
            <p>暂无规章制度</p>
          </div>
        </div>
      </popup>
    </transition>
    <transition name="slide-left-fade">
      <popup title="固定资产" class="people-pop" v-if="isShowGD" width="775px" @closeEvent="isShowGD = false">
        <div class="more-content">
          <el-carousel height="225px" :indicator-position="list.length>1?'outside':'none'"
              :arrow="list.length>1?'hover':'never'" v-if="list&&list.length>0">
            <el-carousel-item v-for="(item, index) in list" :key="index">
              <el-row class="shi-tsb">
                <el-col :span="12" class="shi-tsb-item" v-for="(sb, i) in item" :key="i">
                  <el-row style="padding: 5px 0">
                    <el-col :span="18" class="shi-tsb-item-left">{{sb.assetDicName}}</el-col>
                    <el-col :span="6" class="shi-tsb-item-right">{{sb.purchaseQty}}</el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
          <div class="no-the-data" style="min-height: 130px" v-if="list && list.length===0">
            <div>
              <i class="iconfont icon-shezhi dzi"></i>
              <p>暂无食堂设备总览</p>
            </div>
          </div>
        </div>
      </popup>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'gdzcGZZD',
    data () {
      return {
        isShowGZ: false,
        deptId: this.$route.query.deptId,
        imgUrl: this.$store.getters.fileApi,
        isShowGD: false,
        list: '',
        regulationInfo: ''
      }
    },
    props: {
      contractorId: {}
    },
    watch: {
      contractorId(cur) {
        this.contractorId = cur
        this.getRegulation()
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.addEventListener('click', (e) => {
          if (e.target.className === 'point') {
            this.isShowGD = false
            this.isShowGZ = false
          }
        })
      })
    },
    methods: {
      /**
       * @Description: 获取食堂设备
       * @author kk
       * @date 2019/11/6
       */
      getAssetStatistics () {
        this.$request.assetStatistics({departmentId: this.deptId}).then(res => {
          console.log('食堂设备总览', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.list = []
            let tmpList = res.list
            for (var i = 0; i < tmpList.length; i += 16) {
              this.list.push(tmpList.slice(i, i + 16))
            }
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description: 显示固定资产
       * @author kk
       * @date 2019/11/8
       */
      ShowGD () {
        this.isShowGD = !this.isShowGD
        this.isShowGZ = false
        this.getAssetStatistics()
      },
      /**
       * @Description: 显示规章制度
       * @author kk
       * @date 2019/11/8
       */
      ShowGZ () {
        this.isShowGZ = !this.isShowGZ
        this.isShowGD = false
        this.getRegulation()
      },
      /**
       * @Description: 获取规章制度
       * @author kk
       * @date 2019/11/8
       */
      getRegulation () {
        this.$request.regulationGet({departmentId: this.deptId, orgId: this.contractorId}).then(res => {
          console.log('规章制度', res)
          this.regulationInfo = res
        }).catch(e => {
          console.log(e, 'eeeeeeeeeeeeeeeee')
        })
      },
      /**
       * @Description: 显示图片框
       * @author kk
       * @date 2019/11/7
       */
      showPic (item) {
        this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then(() => {
        }).catch(() => {
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .gd-gz-box {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .btn {
      width: 100%;
      background-color: rgba(8, 129, 143, .1);
      height: 50px;
      line-height: 40px;
      padding: 5px;
      color: #fff;
      padding-left: 50px;
      font-size: 16px;
      position: relative;
      text-align: left;
      cursor: pointer;

      img {
        margin: 5px;
        position: absolute;
        left: 5px;
      }

      i {
        position: absolute;
        right: 10px;
        top: 17px;
        color: #00fffc;
      }
    }
  }

  .more-content{
    .el-carousel--horizontal{
      margin-bottom: 0;
    }
  }
  .info-img{
    img{
      margin-top: 10px;
      max-width: 100%;
      cursor: pointer;
    }
  }
  .info-content {
    word-break: break-all;
  }
  .regulation-content {
    color: #fff;
    span, p, div, a, dl, dd, dt, ul, li, ol, b{
      color: #fff !important;
      font-size: 14px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/gdzcGZZD.vue